import { render, staticRenderFns } from "./PortfolioByTag.vue?vue&type=template&id=6625184b&scoped=true&"
import script from "./PortfolioByTag.vue?vue&type=script&lang=js&"
export * from "./PortfolioByTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6625184b",
  null
  
)

export default component.exports